import WidgetConfigContext from './WidgetConfigContext';
import WidgetConfigProvider from './WidgetConfigProvider';
import useWidgetConfig from './useWidgetConfig';
import withWidgetConfig from './withWidgetConfig';

export { WidgetConfigContext, WidgetConfigProvider, withWidgetConfig };

export default useWidgetConfig;
